import { UserType } from "@fixa/notifications";

export function getTitleAssignerString({
  firstName,
  lastName,
  fullName,
}: UserType) {
  if (firstName && lastName) {
    return `${firstName} ${Array.from(lastName)[0]}.`;
  } else if (firstName) {
    return firstName;
  } else if (lastName) {
    return lastName;
  } else if (fullName) {
    return fullName;
  }
  return "";
}
